import _capitalize from 'lodash/capitalize';

import { OrganizationRole } from ':cloud/types/ts_types';

export function formatRole(role: OrganizationRole) {
  return _capitalize(role.replace('ROLE_', '').toLowerCase());
}
